"use client"

import { Switch } from '../../../shared/components/ui/switch'
import { FormControl, FormDescription, FormField, FormItem, FormLabel } from '@/shared/components/ui/form'
import React from 'react'
import { FieldValues, FieldPath, Control } from 'react-hook-form'

type InputWithToggleProps<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> = {
    title: string,
    description: string,
    name: TName,
    control: Control<TFieldValues>
}

function InputWithToggle<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({ title, description, name, control }: InputWithToggleProps<TFieldValues, TName>) {
    return (
        <FormField
            control={control}
            name={name}
            render={({ field }) => (
                <FormItem className="flex justify-between items-center w-full">
                    <div className='space-y-0.5'>
                        <FormLabel className='scroll-m-20 text-base font-semibold tracking-tight'>{title}</FormLabel>
                        <FormDescription className='text-muted-foreground text-sm'>{description}</FormDescription>
                    </div>
                    <FormControl>
                        <Switch
                            checked={field.value}
                            onCheckedChange={field.onChange}
                        />
                    </FormControl>
                </FormItem>
            )} 
        />
    )
}

export default InputWithToggle